/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, doT) {
	'use strict';
	/*jshint smarttabs:false */
	/**
	 * Address with Type-Ahead uses the GAIA Webservice to
	 * render list of suggestions to the user using the address
	 * fields in this set.
	 *
	 * As the M@p Service will be removed from portal as of November 2016, pre-fill from
	 * M@p values has been removed from this component.
	 *
	 * @author Matthias Inauen
	 * @namespace Tc.Module.AutoSuggestAddress
	 * @class AutoSuggestAddress
	 * @decorator ZipAndCity
	 * @extends Tc.Module
	 *
	 * @terrificjs-channels    autosuggestaddress
	 * @fires zipCityLoaded, zipCityStart
	 * @handles onZipCityLoaded
	 */
	var FIELD_MAPPINGS = Module.AutoSuggestAddress.FIELD_MAPPINGS;
	var SWITZERLAND_COUNTRY_VALUES = ['ch', 'schweiz', 'switzerland', 'suisse', 'svizzera'];
	var LIECHTENSTEIN_COUNTRY_VALUES = ['li', 'liechtenstein'];

	Module.AutoSuggestAddress.ZipAndCity = function () {

		this.initComponent = function () {
			this.$zipInput = this.$ctx.find('.zip input');
			this.$cityInput = this.$ctx.find('.city input');

			this.$countryDropdown = this.$ctx.is('.withCountry') ? this.$ctx.find('.zipCountry > .country select') : $([]);
			if (this.$countryDropdown.length) {
				this.countryChanged();
			}

			this.$allAddressInputFields = this.$ctx.find('input').not('[type="hidden"]').not('input[readonly]');
		};

		this.cacheTemplates = function () {
			var zipFieldName, cityFieldName;

			zipFieldName = this.$zipInput.attr('name');
			cityFieldName = this.$cityInput.attr('name');

			FIELD_MAPPINGS[zipFieldName] = {datakey: 'zipCity', valuekey: 'zipCity', matchStart: true};
			FIELD_MAPPINGS[cityFieldName] = {datakey: 'zipCity', valuekey: 'zipCity', matchStart: false};

			this.templateCache[FIELD_MAPPINGS[zipFieldName].datakey] = doT.template(this.$ctx.find('script.tmpl-zipcity').html());
		};

		this.addEventListeners = function () {
			this.$ctx.on('mouseenter', $.proxy(this.handleFirstInteraction, this));
			this.typeAheadListUl.on('click', 'li:not(.nomatch)', $.proxy(this.handleListItemSelected, this));
			this.typeAheadList.on('mouseenter', $.proxy(this.handleListFocus, this));
			this.typeAheadList.on('mouseleave', $.proxy(this.handleListFocus, this));
			this.$allAddressInputFields.on('focusin', $.proxy(this.handleFirstInteraction, this));
			this.$allAddressInputFields.on('focusin', $.proxy(this.handleInputFocusIn, this));
			this.$allAddressInputFields.on('blur', $.proxy(this.handleInputFocusOut, this));

			this.$countryDropdown.on('change', $.proxy(this.countryChanged, this));
		};

		this.countryChanged = function (event) {
			var prevDisableAutosuggest = this.disableAutosuggest;
			var val = String(this.$countryDropdown.val()).toLowerCase();
			var isSwitzerland = $.inArray(val, SWITZERLAND_COUNTRY_VALUES) > -1;
			var isLiechtenstein = $.inArray(val, LIECHTENSTEIN_COUNTRY_VALUES) > -1;
			this.disableAutosuggest = !isSwitzerland && !isLiechtenstein;
			if (this.disableAutosuggest !== prevDisableAutosuggest) {
				// State change, remove previous values
				this.$zipInput.val('');
				this.$cityInput.val('');
			}
			if (isLiechtenstein && this.$zipInput.val() === '') {
				this.$zipInput.val('94');
			}
			if (event) {
				// Do not focus for the initial selection
				this.$zipInput.focus();
			}
		};

		// override, cause nothing has to be done here.
		this.setFieldAccess = $.noop;

		// there is only zip or city here.
		this.isZipOrCity = function () {
			return true;
		};

		this.formIsComplete = function () {
			return (this.$zipInput.val().length && this.$cityInput.val().length);
		};
	};
})(window.Tc.Module, window.Tc.$, window.doT);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.AutoSuggestAddress.ZipAndCity.js
// module id = 269
// module chunks = 0